// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> weidner-apartment-homes-rise-rise -> atrium-court
// Generated: 2026-10-27T17:11:44.025Z
// Counts: 0 design, 28 content, 8 slot group, 0 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Settle into a bright, welcoming home at Atrium Court, where your days are filled with possibility and comfort. Located two blocks from Harkins Theater and minutes from Fry’s, Rose Mofford dog park, and neighborhood shopping centers, our Phoenix apartments put you right where you want to be. Here, relaxation meets convenience - from covered parking to free Wi-Fi in community spaces, every detail is designed for more easygoing days. Atrium Court is pet friendly and sits amid mature landscaping, making it the perfect spot to connect, unwind, and enjoy life in Phoenix.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether relaxing by the pool, grilling with neighbors, or coming home to cool air conditioning, Atrium Court’s amenities make every day feel effortless. Kick back at our two swimming pools or soothe your muscles in the spa. Stay active in the 24-hour fitness center, and take care of business with on-site Wi-Fi. With modern appliances and thoughtful extras inside your apartment, comfort is always close at hand. Pet lovers and residents alike appreciate our welcoming, smoke-free community and flexible spaces for gathering or downtime.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=48/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments In <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>LOVE WHERE YOU LIVE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Atrium Court in Phoenix, everyday conveniences and special touches blend to create a space you’ll look forward to coming home to. Enjoy life around two sparkling swimming pools, make the most of community Wi-Fi, and get active any time in the 24-hour fitness center. Inside, each apartment offers central air and heating, a complete kitchen appliance package, and extra storage. Covered parking and pet-friendly policies round out the experience, creating a welcoming place to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have a question about our apartments or want help scheduling your tour? Reach out to the Atrium Court leasing team in Phoenix - we're here to help you find a home that fits your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Featuring all-in-pricing.</strong><span style=\"font-size: 18px;\">&nbsp;One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Atrium Court offers a variety of one and two bedroom layouts designed to fit your lifestyle. Each apartment comes with central air conditioning and heating to keep you comfortable year-round, a complete kitchen appliance package for easy meals, and extra storage space for all your essentials. Whether you need room for a home office, a cozy spot to relax, or an airy layout for entertaining friends, you’ll find the balance of comfort and functionality here in Phoenix.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside Atrium Court through vivid photos that showcase bright apartments, lush lawns, and places to unwind or gather. Find inspiration in kitchens ready for late-night snacks, spacious living areas for kicking back, and tranquil pool scenes perfect for sunny Phoenix afternoons. See how our welcoming spaces and modern style can make you feel at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Atrium Court in Phoenix means city convenience with a neighborhood vibe. Dive into local flavors at restaurants near Harkins Theater, pick up fresh groceries at Fry’s, or spend sunny afternoons with your dog at Rose Mofford dog park. Surrounded by shopping centers and public spaces, our area makes errands a breeze and evenings out simple. Parks, transit options, and local favorites are just around the corner - all putting Phoenix’s best within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Pit Bull &amp; Pit Bull Mixes&nbsp;</p></li><li><p>American Pit Bull Terrier&nbsp;</p></li><li><p>American Staffordshire Terrier&nbsp;</p></li><li><p>Wolf Hybrids&nbsp;</p></li><li><p>Doberman Pinscher&nbsp;</p></li><li><p>Saint Bernard&nbsp;</p></li><li><p>American Bulldog&nbsp;</p></li><li><p>Staffordshire Bull Terrier&nbsp;</p></li><li><p>Rottweiler&nbsp;</p></li><li><p>German Shepherd&nbsp;</p></li><li><p>Chow Chow&nbsp;</p></li><li><p>Great Dane&nbsp;</p></li><li><p>Akita</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to North Phoenix Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to see your next home? Atrium Court makes touring easy with multiple ways to explore. Book a guided in-person visit, enjoy a live virtual walk-through with a leasing team member, or start with a quick, self-paced online tour. Find out just how comfortable and welcoming our apartments can be and experience the vibrant energy of our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Everyday Comforts and Connections</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a true feel for city living at Atrium Court without leaving your couch. Our virtual tour lets you see inside our welcoming apartments, community spaces, and beautifully landscaped grounds at your own pace. Imagine waking up to sunlight streaming through your windows or enjoying moments by the pool - all from the comfort of your screen. Start your journey and picture your life here in Phoenix before you even step inside.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_business_url"
      }
    }
  },
  "footer.love_notes_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3412-75a9-9aac-8f5678cb59df.webp"
      }
    }
  },
  "footer.weidner_cares_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3452-767e-8966-83b6939f057f.webp"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "tabbedcallouts.panel2_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "tabbedcallouts.panel3_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
